
<template>
    <div :class="{'w-100': lengthOfValues > 1}">

        <p v-for="(item, key) in cptOrderedValues" v-bind:key="key" class="add-edit-apron-selected-value">
            <span v-if="item.name.length == 0">{{ $t('general.none') }}:</span>
            <span>{{item.name}}:</span>
            <span class="add-edit-apron-selected-value-number">{{item.number}}</span>
        </p>
        <button v-if="Object.keys(this.selectedValue).length > 1" @click="toggle" class="add-edit-apron-view-more">{{ buttonLabel}}</button>

    </div>
</template>

<script>
    var _ = require('lodash');

    export default {
        name: 'UniquePropCounter',
        props: {
            selectedValue: {}
        },
        data: function () {
            return {
                lengthOfValues: 1,
				buttonLabel: this.$t('general.showAll', [ Object.keys(this.selectedValue).length ])
            }

        },
        methods: {
            toggle: function () {
                if (this.lengthOfValues == 1) {
                    this.lengthOfValues = Object.keys(this.selectedValue).length
                    this.buttonLabel = this.$t('general.showLess')
                    return
                } if (this.lengthOfValues == Object.keys(this.selectedValue).length) {
                    this.lengthOfValues = 1
					this.buttonLabel = this.$t('general.showAll', [ Object.keys(this.selectedValue).length ])
                    return
                }

            }
        },
        computed: {
            cptOrderedValues: function () {
                const arr = []
                Object.entries(this.selectedValue).forEach(([key, value]) => arr.push({name: key, number: value}) )
                return _.sortBy(arr, 'name', 'desc').slice(0, this.lengthOfValues)
            },
        }
    }
</script>
